import React, { useRef, useEffect, useCallback, useState} from 'react';
import SimplePlayer from "components/spore/SimplePlayer.js";
import {useConsumeWheel} from "components/hooks/useConsumeWheel.js"
import SporeItem from './SporeItem.js';
import {getAllSpores} from './getSpores.js';
import {connect} from 'react-redux';

const SporesView = ({setShowStemPlayer, tokenId}) => { 
    let [spores, setSpores] = useState([]);
    let ref = useRef();
    let [selected, setSelected] = useState();

    useEffect(() => {
        console.log("token id in sporesview=", tokenId);
        getAllSpores(tokenId).then((spores) => {
            setSpores(spores);
        });
    }, [setSpores, tokenId]);

    useConsumeWheel(ref);


    return (
        <div className="list-and-player">
          <div ref={ref} className="spores-list">
            {spores.length === 0 && <div className="no-spores-yet">No spores have been detected on-chain.</div>}
            {spores.map(x =>
                <SporeItem isSelected={x === selected} setSelected={setSelected} spore={x}/>)}
          </div>
          {selected && <SimplePlayer selected={selected} setShowStemPlayer={setShowStemPlayer}/>}
          
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SporesView);
